const { cELM, Wrap4ArrowMulti, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class BloodPressureInputV2 {
  constructor(data) {
    this.data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const inputContainer = cELM("div", "inputs-wrapper");
    const feetEl = cELM("input", "number-input");
    const inchEl = cELM("input", "number-input");

    const _self = this;

    feetEl.type = "number";
    inchEl.pattern = "[0-9]*";
    feetEl.placeholder = "Tap to add #";
    inchEl.type = "number";
    feetEl.pattern = "[0-9]*";
    feetEl.maxlength = "3";
    feetEl.max = "999";
    inchEl.placeholder = "Tap to add #";
    inchEl.maxlength = "3";
    inchEl.max = "999";

    const buttonEl = cELM("div", "continue-button", "Submit");
    const skipButton = cELM('div', 'continue-button skip-button', "Don't Know");

    const btnWrap = Wrap4Arrow(buttonEl);
    
    const btnRow = cELM('div', 'row row-buttons');

    btnRow.addELM(skipButton);
    btnRow.addELM(btnWrap);

    const feetWrp = Wrap4ArrowMulti(feetEl, true);
    const inchWrp = Wrap4ArrowMulti(inchEl);

    buttonEl.onclick = function(evt) {
      if (_self.validate()) {
        const op = feetEl.value + "/" + inchEl.value;
        Chat.default.send({
            text: op,
            id: _self.data.id
          }, 
          null, 
          _self.element
        );
      }
    };

    skipButton.onclick = function(evt) {
        const op = "don't know";
        Chat.default.send({
            text: op,
            id: _self.data.id
          }, 
          null, 
          _self.element
        );
    }

    let feetElTimer, inchElTimer;
    feetEl.onkeyup = function(evt){
        clearTimeout(feetElTimer);


        const regex = /[0-9]|\./;
        if(regex.test(evt.target.value) && evt.target.value.length == 3) {
            inchEl.focus();
            return;
        }

        feetElTimer = setTimeout(() => {
            const regex = /[0-9]|\./;
            if(regex.test(evt.target.value) || evt.target.value.length == 3) {
                inchEl.focus();
            }

            if (_self.validate()) {
                feetWrp.classList.remove("arrow-active");
                inchWrp.classList.remove("arrow-active");
                buttonEl.classList.add("continue-button-active");
                btnWrap.classList.add("arrow-active");

                if (evt.key === "Enter") {
                    el.blur();
                    buttonEl.click();
                }
            } else {
                buttonEl.classList.remove("continue-button-active");
                btnWrap.classList.remove("arrow-active");
            }
        }, 2000);
    };

    inchEl.onkeyup = function(evt) {
        if (_self.validate()) {
            feetWrp.classList.remove("arrow-active");
            inchWrp.classList.remove("arrow-active");
            buttonEl.classList.add("continue-button-active");
            btnWrap.classList.add("arrow-active");
        } else {
            buttonEl.classList.remove("continue-button-active");
            btnWrap.classList.remove("arrow-active");
        }

        if(evt.key === 'Enter') {
          buttonEl.click();
        }
    };


    const onlyNumbers = function(evt) {
        const theEvent = evt || window.event;

        // Handle paste
        let key;
        if (theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
          // Handle key press
          key = theEvent.keyCode || theEvent.which;
          key = String.fromCharCode(key);
        }
        const regex = /[0-9]|\./;
        if(!regex.test(key) || (evt.target.value + key).length > 3) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    };

    feetEl.onkeypress = onlyNumbers;
    inchEl.onkeypress = onlyNumbers;


    // feetEl.onkeydown = onKeyDown;
    // inchEl.onkeydown = onKeyDown;
   
    inputContainer.addELM(feetWrp);
    inputContainer.addELM(cELM("div", "slash", "/"));
    inputContainer.addELM(inchWrp);
    this.element.addELM(inputContainer);
    this.element.addELM(btnRow);
    this.__elements = { feetEl, inchEl };
    return this.element;
  }

  validate() {
    let valid = true;
    const { feetEl, inchEl } = this.__elements;
    feetEl.classList.remove("invalid");
    inchEl.classList.remove("invalid");

    if (!feetEl.value || Number.isNaN(parseInt(feetEl.value))) {
      feetEl.classList.add("invalid");
      valid = false;
    }
    if (!inchEl.value || Number.isNaN(parseInt(inchEl.value))) {
      inchEl.classList.add("invalid");
      valid = false;
    }

    return valid;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.feetEl.value = "";
    this.__elements.inchEl.value = "";
    this.__elements.feetEl.focus();
  }

  focus() {
    //this.__elements.feetEl.focus();
  }
}

module.exports = BloodPressureInputV2;
